import type { MapTheme, TerrainOnlyTileKind } from "../engine/types/primitives";

const SPRITE_TERRAIN_OVERLAY_KINDS: ReadonlySet<TerrainOnlyTileKind> = new Set([
  "forest",
  "mountain",
  "dropZone",
]);

const SPRITE_TERRAIN_FULL_TILE: ReadonlySet<TerrainOnlyTileKind> = new Set(["sea"]);

export function usesSpriteTerrainOverlay({
  kind,
}: {
  theme?: MapTheme;
  kind: TerrainOnlyTileKind;
}): boolean {
  return SPRITE_TERRAIN_OVERLAY_KINDS.has(kind);
}

export function usesSpriteTerrainFullTile({ kind }: { kind: TerrainOnlyTileKind }): boolean {
  return SPRITE_TERRAIN_FULL_TILE.has(kind);
}

export function usesSpriteTerrain({
  theme,
  kind,
}: {
  theme?: MapTheme;
  kind: TerrainOnlyTileKind;
}): boolean {
  return usesSpriteTerrainOverlay({ theme, kind }) || usesSpriteTerrainFullTile({ kind });
}
